import type { AxiosRequestConfig } from 'axios'
import { attach, createEvent, createStore } from 'effector'
import qs from 'qs'

import { API_ROOT } from '../../config'
import { $sessionToken } from './session.model'

const DEFAULT_AXIOS_CONFIG: Partial<AxiosRequestConfig> = {
  baseURL: API_ROOT,
  paramsSerializer: {
    serialize: (params: unknown) =>
      qs.stringify(params, {
        arrayFormat: 'repeat',
        encode: false,
        skipNulls: true,
      }),
  },
}

export const axiosInitialized = createEvent()
export const axiosConfigSet =
  createEvent<Pick<AxiosRequestConfig, 'baseURL' | 'headers'>>()

export const $axiosConfig = createStore<Partial<AxiosRequestConfig>>(
  DEFAULT_AXIOS_CONFIG,
)
  .on(axiosConfigSet, (state, payload) => ({
    ...state,
    ...payload,
  }))
  .on($sessionToken, (state, token) => ({
    ...state,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  }))
  .reset(axiosInitialized)

export const getAxiosConfigFx = attach({
  source: $axiosConfig,
  effect: (config) => config,
})
